/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1AccessLoginMutationRequest,
  PostApiV1AccessLoginMutationResponse,
  PostApiV1AccessLogin400,
  PostApiV1AccessLogin500,
} from "../../types/accessController/PostApiV1AccessLogin.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1AccessLogin } from "../../clients/accessController/postApiV1AccessLogin.ts";

export const postApiV1AccessLoginMutationKey = () =>
  [{ url: "/api/v1/access/login" }] as const;

export type PostApiV1AccessLoginMutationKey = ReturnType<
  typeof postApiV1AccessLoginMutationKey
>;

export function postApiV1AccessLoginMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1AccessLoginMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1AccessLoginMutationKey();
  return mutationOptions<
    PostApiV1AccessLoginMutationResponse,
    ResponseErrorConfig<PostApiV1AccessLogin400 | PostApiV1AccessLogin500>,
    { data: PostApiV1AccessLoginMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1AccessLogin(data, config);
    },
  });
}

/**
 * @description Autentica um usuário e retorna um token.
 * @summary Realizar login no sistema
 * {@link /api/v1/access/login}
 */
export function usePostApiV1AccessLogin<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1AccessLoginMutationResponse,
      ResponseErrorConfig<PostApiV1AccessLogin400 | PostApiV1AccessLogin500>,
      { data: PostApiV1AccessLoginMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1AccessLoginMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1AccessLoginMutationKey();

  const baseOptions = postApiV1AccessLoginMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1AccessLoginMutationResponse,
    ResponseErrorConfig<PostApiV1AccessLogin400 | PostApiV1AccessLogin500>,
    { data: PostApiV1AccessLoginMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1AccessLoginMutationResponse,
    ResponseErrorConfig<PostApiV1AccessLogin400 | PostApiV1AccessLogin500>,
    { data: PostApiV1AccessLoginMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1AccessLoginMutationResponse,
    ResponseErrorConfig<PostApiV1AccessLogin400 | PostApiV1AccessLogin500>,
    { data: PostApiV1AccessLoginMutationRequest },
    TContext
  >;
}
